import { render, staticRenderFns } from "./ClassNotes.vue?vue&type=template&id=5bfe0d20&scoped=true"
import script from "./ClassNotes.vue?vue&type=script&lang=js"
export * from "./ClassNotes.vue?vue&type=script&lang=js"
import style0 from "./ClassNotes.vue?vue&type=style&index=0&id=5bfe0d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe0d20",
  null
  
)

export default component.exports